var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusInsideSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1303 0.5H3.20172C1.52597 0.501992 0.168008 1.85995 0.166016 3.53571V14.4643C0.168008 16.14 1.52597 17.498 3.20172 17.5H14.1303C15.8061 17.498 17.164 16.14 17.166 14.4643V3.53571C17.164 1.85995 15.8061 0.501992 14.1303 0.5ZM15.9517 14.4643C15.9517 15.4702 15.1363 16.2857 14.1303 16.2857H3.20172C2.19577 16.2857 1.38029 15.4702 1.38029 14.4643V3.53571C1.38029 2.52976 2.19577 1.71428 3.20172 1.71428H14.1303C15.1363 1.71428 15.9517 2.52976 15.9517 3.53571V14.4643Z",
    fill: "#B6B6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.702 8.39365H9.27346V5.96507C9.27346 5.62974 9.00163 5.35791 8.6663 5.35791C8.33097 5.35791 8.05914 5.62974 8.05914 5.96507V8.39365H5.63059C5.29526 8.39365 5.02344 8.66548 5.02344 9.00081C5.02344 9.33614 5.29526 9.60793 5.63059 9.60793H8.05918V12.0365C8.05918 12.3718 8.33101 12.6437 8.66634 12.6437C9.00166 12.6437 9.27346 12.3718 9.27346 12.0365V9.60793H11.702C12.0374 9.60793 12.3092 9.3361 12.3092 9.00077C12.3092 8.66544 12.0373 8.39365 11.702 8.39365Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInsideSquare);
export default __webpack_public_path__ + "static/media/plusInsideSquare.80a99c691fa7684fa07a5b588fc5a482.svg";
export { ForwardRef as ReactComponent };